import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

const messages = {
  en: {
    welcome: "Welcome",
    conditions_title: "Terms and Conditions",
    member_since: "Member since",
    terms: {
      purpose_title: "Purpose",
      purpose_text: "This app identifies you as a consecrated member. It is intended for identification, participation in religious activities, and obtaining benefits related to your consecrated life.",
      conditions_title: "Conditions of Use",
      conditions_text: "- The profile is personal and non-transferable. \n - Information should be true and accurate. \n - You are responsible for maintaining the confidentiality of your account. \n - Use the app responsibly and in accordance with all applicable laws. \n - The app should be used in a manner that reflects the sobriety, modesty, and dignity of consecrated life.",
      validity_title: "Validity",
      validity_text: "Your profile remains valid as long as you remain a member. Any misuse or falsification will invalidate your profile.",
      responsibility_title: "Responsibility",
      responsibility_text: "The app reserves the right to validate or revoke any profile. Report any misuse or loss of information to the app administration.",
      data_title: "Personal Data",
      data_text: "The data contained in this app is confidential and used exclusively for the established identification purposes."
    }
  },
  es: {
    welcome: "Bienvenido",
    conditions_title: "Términos y Condiciones",
    member_since: "Miembro desde el",
    terms: {
      purpose_title: "Propósito",
      purpose_text: "Esta aplicación te identifica como miembro consagrada. Su uso es exclusivo para fines de identificación, participación en actividades religiosas y obtención de beneficios relacionados con su estado de vida consagrada.",
      conditions_title: "Condiciones de Uso",
      conditions_text: "- El perfil es personal e intransferible. \n - La información debe ser verdadera y precisa. \n - Usted es responsable de mantener la confidencialidad de su cuenta. \n - Utilice la aplicación de forma responsable y de acuerdo con todas las leyes aplicables. \n - La aplicación debe utilizarse de manera que refleje la sobriedad, modestia y dignidad de la vida consagrada.",
      validity_title: "Validez",
      validity_text: "Su perfil sigue siendo válido mientras usted siga siendo miembro. Cualquier mal uso o falsificación invalidará su perfil.",
      responsibility_title: "Responsabilidad",
      responsibility_text: "La aplicación se reserva el derecho de validar o revocar cualquier perfil. Informe de cualquier uso indebido o pérdida de información a la administración de la aplicación.",
      data_title: "Datos Personales",
      data_text: "Los datos contenidos en esta aplicación son confidenciales y se utilizan exclusivamente para los fines de identificación establecidos."
    }
  },
  it: {
    welcome: "Benvenuto",
    conditions_title: "Termini e Condizioni",
    member_since: "Membro dal",
    terms: {
      purpose_title: "Scopo",
      purpose_text: "Questa app ti identifica come membro consacrato. È inteso per l'identificazione, la partecipazione alle attività religiose e l'ottenimento di benefici relativi alla tua vita consacrata.",
      conditions_title: "Condizioni d'uso",
      conditions_text: "- Il profilo è personale e non trasferibile. \n - Le informazioni devono essere vere e accurate. \n - Sei responsabile del mantenimento della riservatezza del tuo account. \n - Utilizzare l'app in modo responsabile e in conformità con tutte le leggi applicabili. \n - L'app deve essere utilizzata in modo da riflettere la sobrietà, la modestia e la dignità della vita consacrata.",
      validity_title: "Validità",
      validity_text: "Il tuo profilo rimane valido finché rimani un membro. Qualsiasi uso improprio o falsificazione invaliderà il tuo profilo.",
      responsibility_title: "Responsabilità",
      responsibility_text: "L'app si riserva il diritto di convalidare o revocare qualsiasi profilo. Segnala qualsiasi uso improprio o perdita di informazioni all'amministrazione dell'app.",
      data_title: "Dati personali",
      data_text: "I dati contenuti in questa app sono riservati e vengono utilizzati esclusivamente per le finalità di identificazione stabilite."
    }
  },
  pt: {
    welcome: "Bem-vindo",
    conditions_title: "Termos e Condições",
    member_since: "Membro desde",
    terms: {
      purpose_title: "Objetivo",
      purpose_text: "Este aplicativo identifica você como membro consagrado. Destina-se à identificação, participação em atividades religiosas e obtenção de benefícios relacionados à sua vida consagrada.",
      conditions_title: "Condições de Uso",
      conditions_text: "- O perfil é pessoal e intransferível. \n - As informações devem ser verdadeiras e precisas. \n - Você é responsável por manter a confidencialidade da sua conta. \n - Use o aplicativo de forma responsável e de acordo com todas as leis aplicáveis. \n - O aplicativo deve ser usado de forma a refletir a sobriedade, a modéstia e a dignidade da vida consagrada.",
      validity_title: "Validade",
      validity_text: "Seu perfil permanece válido enquanto você permanecer um membro. Qualquer uso indevido ou falsificação invalidará seu perfil.",
      responsibility_title: "Responsabilidade",
      responsibility_text: "O aplicativo se reserva o direito de validar ou revogar qualquer perfil. Relate qualquer uso indevido ou perda de informações à administração do aplicativo.",
      data_title: "Dados Pessoais",
      data_text: "Os dados contidos neste aplicativo são confidenciais e são usados ​​exclusivamente para as finalidades de identificação estabelecidas."
    }
  },
  fr: {
    welcome: "Bienvenue",
    conditions_title: "Termes et Conditions",
    member_since: "Membre depuis",
    terms: {
      purpose_title: "Objet",
      purpose_text: "Cette application vous identifie en tant que membre consacré. Elle est destinée à l'identification, à la participation à des activités religieuses et à l'obtention d'avantages liés à votre vie consacrée.",
      conditions_title: "Conditions d'utilisation",
      conditions_text: "- Le profil est personnel et non transférable. \n - Les informations doivent être vraies et exactes. \n - Vous êtes responsable du maintien de la confidentialité de votre compte. \n - Utilisez l'application de manière responsable et conformément à toutes les lois applicables. \n - L'application doit être utilisée de manière à refléter la sobriété, la modestie et la dignité de la vie consacrée.",
      validity_title: "Validité",
      validity_text: "Votre profil reste valide tant que vous restez membre. Toute utilisation abusive ou falsification invalidera votre profil.",
      responsibility_title: "Responsabilité",
      responsibility_text: "L'application se réserve le droit de valider ou de révoquer tout profil. Signalez toute utilisation abusive ou perte d'informations à l'administration de l'application.",
      data_title: "Données personnelles",
      data_text: "Les données contenues dans cette application sont confidentielles et sont utilisées exclusivement aux fins d'identification établies."
    }
  },
  de: {
    welcome: "Willkommen",
    conditions_title: "Nutzungsbedingungen",
    member_since: "Mitglied seit",
    terms: {
      purpose_title: "Zweck",
      purpose_text: "Diese App identifiziert Sie als geweihtes Mitglied. Sie ist für die Identifizierung, die Teilnahme an religiösen Aktivitäten und den Erhalt von Vorteilen im Zusammenhang mit Ihrem geweihten Leben bestimmt.",
      conditions_title: "Nutzungsbedingungen",
      conditions_text: "- Das Profil ist persönlich und nicht übertragbar. \n - Die Informationen sollten wahrheitsgetreu und korrekt sein. \n - Sie sind für die Wahrung der Vertraulichkeit Ihres Kontos verantwortlich. \n - Nutzen Sie die App verantwortungsvoll und in Übereinstimmung mit allen geltenden Gesetzen. \n - Die App sollte in einer Weise verwendet werden, die die Nüchternheit, Bescheidenheit und Würde des geweihten Lebens widerspiegelt.",
      validity_title: "Gültigkeit",
      validity_text: "Ihr Profil bleibt gültig, solange Sie Mitglied bleiben. Jeder Missbrauch oder jede Fälschung führt zur Ungültigkeit Ihres Profils.",
      responsibility_title: "Verantwortung",
      responsibility_text: "Die App behält sich das Recht vor, jedes Profil zu validieren oder zu widerrufen. Melden Sie jeden Missbrauch oder Verlust von Informationen an die App-Administration.",
      data_title: "Persönliche Daten",
      data_text: "Die in dieser App enthaltenen Daten sind vertraulich und werden ausschließlich für die festgelegten Identifikationszwecke verwendet."
    }
  }
};

// Detect the user's preferred language 
const i18n = new VueI18n({
  locale: "es",
  fallbackLocale: "es",
  messages,
});

export default i18n;
